import React, { createContext, useContext, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

const InlineToastContext = createContext();

export const useInlineToast = () => {
    const ctx = useContext(InlineToastContext);
    if (!ctx) throw new Error('useInlineToast must be used inside InlineToastProvider');
    return ctx;
};

export const InlineToastProvider = ({ children }) => {
    const [zones, setZones] = useState({}); 

    const addToast = (zone, message, type = 'info') => {
        const id = uuidv4();
        const newToast = { id, message, type };

        setZones(prev => ({
            ...prev,
            [zone]: [...(prev[zone] || []), newToast],
        }));
    };

    const removeToast = (zone, id) => {
        setZones(prev => ({
            ...prev,
            [zone]: (prev[zone] || []).filter(t => t.id !== id),
        }));
    };

    return (
        <InlineToastContext.Provider value={{ zones, addToast, removeToast }}>
            {children}
        </InlineToastContext.Provider>
    );
};
